/**
 * FRONT-2937: the sentence in a refused turn's 429 body when the compute
 * budget is spent (`usage_limit_reached`, `src/limits/gate.ts`), or null for
 * any other failure. Its `error` is a code; `message` is for the person.
 */
export function budgetRefusalMessage(err: unknown): string | null {
  const body = (err as { status?: unknown; body?: { error?: unknown; message?: unknown } } | null)?.body;
  if (body?.error !== 'usage_limit_reached') return null;
  return typeof body.message === 'string' && body.message ? body.message : null;
}

/** A turn refused because the person's compute budget is spent; its message is the sentence for them. */
export class BudgetRefusedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BudgetRefusedError';
  }
}

/**
 * The one reading of a refused turn for every Builder door (send, answer, update):
 * on a spent budget, `refresh` runs once so the budget card and composer lock
 * appear, and the error to throw carries the sentence. Null for any other failure.
 */
export function budgetRefused(err: unknown, refresh: () => void): BudgetRefusedError | null {
  const spent = budgetRefusalMessage(err);
  if (!spent) return null;
  refresh();
  return new BudgetRefusedError(spent);
}
